import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Select, SelectOptionWithGroup } from 'tea-component';
import { TYPES_MAPPING } from '../constants';

import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IType } from '../types';

interface ITypeSelectProps extends IBaseProps {
  disabled?: boolean;
  value: IType;
  onChange: (payload: IType) => void;
}

const TypeSelect: React.FC<ITypeSelectProps> = (props) => {
  const { disabled = false, value, onChange, style, className } = props;

  const { formatMessage } = useIntl();

  const options: SelectOptionWithGroup[] = [
    {
      value: TYPES_MAPPING.MULTIPLE,
      text: formatMessage({ id: 'dbi_multiple_regions' }),
    },
    {
      value: TYPES_MAPPING.SINGLE,
      text: formatMessage({ id: 'dbi_single_region' }),
    },
  ];

  const handeChange = (payload: string) => {
    if (payload === value) return;
    onChange?.(payload);
  };

  return (
    <Select
      style={style}
      className={classnames('dbi-composed-country-type-select', className)}
      placeholder={formatMessage({ id: 'dbi_please_select' })}
      appearance="button"
      matchButtonWidth={true}
      disabled={disabled}
      options={options}
      value={value}
      onChange={handeChange}
    />
  );
};

export default TypeSelect;
